import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { IRoles } from 'utilities/roles';

const SWrapper = styled.div`
    position: absolute;
    left: 0;
    top: 64px;
    width: 100%;
    height: calc(100% - 64px);
    display: flex;
    flex-direction: row;
    text-align: center;
    align-items: center;
    background: #FFF;
`;

const SContainer = styled.div`
    width: 700px;
    flex: 2;
`;

const SImg = styled.img`
    height: 400px;
    flex:1
    position: absolute;
    top: 0;
    right: 7%;
    @media (max-width: 1025px) {
        display: none
    }
`;
interface IMapStateToProps {
    userRoles: IRoles[];
}

export class _UnauthorizedPage extends React.Component<IMapStateToProps> {
    public render() {
        return(
            <SWrapper>
                <SContainer>
                    <h1 className="padding-bottom-large"><strong>Oops, you are not authorized to access FinOps.</strong></h1>
                    
                    <p className="large-body-text">Please request access <a href="https://maersk.service-now.com" target="_blank">here</a> if required!</p>
                    
                </SContainer>
                <SImg src={require('./u35198.svg')} />
            </SWrapper>
        );
    }
    // private signOut = () => authentication.signOut();
}; 

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    userRoles: state.user.roles
});

export const UnauthorizedPage = connect(mapStateToProps)(_UnauthorizedPage);